import config from "../config";
// import axios from "@/plugins/axios";
import router from '../Routes';
import * as userApi from '@/api/user';

export default {
  namespaced: true,
  state: {
    isFetching: false,
    errorMessage: '',
    message: '',
    success: false
  },
  mutations: {
    REGISTER_REQUEST(state) {
      state.isFetching = true;
      state.success = false;
      state.message = '';
      state.errorMessage = '';
    },
    REGISTER_SUCCESS(state, payload) {
      state.isFetching = false;
      state.errorMessage = '';
      state.message = payload.message;
      state.success = true;
    },
    REGISTER_FAILURE(state, payload) {
      state.isFetching = false;
      state.errorMessage = payload;
      state.success = false;
      state.message = '';
    },
  },
  actions: {
    registerUser({dispatch}, payload) {
      if (!config.isBackend) {
        router.push('/user/profile');
      }
      else {
        dispatch('requestRegister');
        userApi.register(payload).then((res) => {
          dispatch('receiveRegister', res.data);
        }).catch(err => {
          const response = err.response.data;
          let message = 'Ошибка регистрации';
          if(typeof response.errors === 'object'){
            message = '';
            for (let prop in response.errors) {
              message += `${prop}: `;
              if(Array.isArray(response.errors[prop])){
                for(let err of response.errors[prop]){
                  message += err + "\n";
                }
              }
            }
          }
          dispatch('registerError', message);
        });

        // const creds = payload.creds;
        // if (creds.email.length > 0 && creds.password.length > 0) {
        //   axios.post("/auth/signup", creds).then(() => {
        //     dispatch('receiveRegister');
        //   }).catch(err => {
        //     console.log(err.response.data)
        //     dispatch('registerError', err.response.data);
        //   })
        // } else {
        //   dispatch('registerError', 'Something was wrong. Try again');
        // }
      }
    },
    requestRegister({commit}) {
      commit('REGISTER_REQUEST');
    },
    receiveRegister({commit}, payload) {
      commit('REGISTER_SUCCESS', payload);
    },
    registerError({commit}, payload) {
      commit('REGISTER_FAILURE', payload);
    },
  },
};
